import { Button, Card, Col, Flex, Form, Input, Row } from "antd";
import axiosClient from "../api/axiosClient";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useForm } from "antd/es/form/Form";
import modifyId from "../utils/modifyId";
import handleApiError from "../utils/handleError";

export default function ScheduleSessionForm() {
  const layout = { xs: 24, sm: 24, md: 20, lg: 18 };
  const navigate = useNavigate();
  const [form] = useForm();
  const [voucherDetails, setVoucherDetails] = useState<any>(null);
  const [voucher_id, setVoucherId] = useState<any>(null);

  async function handleFinish() {
    try {
      navigate(`book-slot/${voucher_id}`);
    } catch (error: any) {
      handleApiError(error);
    }
  }

  async function getVoucherDetails(values: any) {
    try {
      form.resetFields();
      setVoucherId(values.voucher_id);
      const res = await axiosClient.get(
        `vouchers/${values.voucher_id}/details`
      );
      setVoucherDetails(res.data);
    } catch (error) {
      handleApiError(error);
    }
  }
  return (
    <Row style={{ marginTop: 60 }} justify="center">
      <Col {...layout} className="schedule_session_card_col">
        <Card bordered={false} className="schedule_session_card">
          <h4>Schedule New Session</h4>
          <p className="schedule_session_hint">
            Enter the voucher issued with your exam to see the slots available
            to you.
          </p>
          <Form
            colon={false}
            layout="vertical"
            form={form}
            onFinish={voucherDetails ? handleFinish : getVoucherDetails}
          >
            {!voucherDetails ? (
              <Form.Item
                label="Exam voucher"
                name="voucher_id"
                rules={[{ required: true, message: "Voucher is required" }]}
              >
                <Input placeholder="e.g. RT-XXXX-XXXX" size="large" />
              </Form.Item>
            ) : null}

            <>
              {voucherDetails ? (
                <>
                  <table className="book_slot_exam_details">
                    <tbody>
                      <tr>
                        <td>Exam ID</td>
                        <td>{modifyId(voucherDetails?.exam_id)}</td>
                      </tr>
                      <tr>
                        <td>Exam Name</td>
                        <td>{voucherDetails?.exam_name}</td>
                      </tr>
                      <tr>
                        <td>Branch Name</td>
                        <td>{voucherDetails?.atc_name}</td>
                      </tr>
                    </tbody>
                  </table>

                  <Flex justify="center" style={{ marginTop: 20 }}>
                    <Button htmlType="button" onClick={handleFinish}>
                      Check Slot Availability
                    </Button>
                  </Flex>
                </>
              ) : (
                <Flex justify="center" style={{ marginTop: 20 }}>
                  <Button htmlType="submit">Verify Voucher</Button>
                </Flex>
              )}
            </>
          </Form>
        </Card>
      </Col>
    </Row>
  );
}
